module.exports = __webpack_public_path__ + "982a1f7093084d5ab5f192fc33a91c53.pdf";